"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStandardLocations = exports.createMultiple = exports.create = void 0;
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageMissionData_1 = require("@voyage/missions/voyageMissionData");
function create(d) {
    var _default = {
        mission: voyageMissionData_1.EVoyageMissionType.Null,
        frames: sprites_sidecar_1.sprites.voyStarmapInvalid,
        dangerLevel: 0,
        text: 'Unknown',
    };
    return Object.assign({}, _default, d);
}
exports.create = create;
function createMultiple(num, d) {
    var locs = [];
    for (var i = 0; i < num; i++) {
        locs.push(create(d));
    }
    return locs;
}
exports.createMultiple = createMultiple;
function generateStandardLocations() {
    var locs = [];
    for (var i = 0; i < 5; i++) {
        locs.push(create({
            text: 'Starbase-' + i,
            mission: voyageMissionData_1.EVoyageMissionType.Starbase,
            dangerLevel: 0,
            frames: sprites_sidecar_1.sprites.voyStarmapStarbase,
        }));
    }
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Enemy territory',
        mission: voyageMissionData_1.EVoyageMissionType.CombatZone1,
        dangerLevel: 1,
        frames: sprites_sidecar_1.sprites.voyStarmapAlienTerritory,
    }))));
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Squid',
        mission: voyageMissionData_1.EVoyageMissionType.FightAlienShip1,
        dangerLevel: 1,
        frames: sprites_sidecar_1.sprites.voyStarmapAlienShip,
    }))));
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Hammerhead',
        mission: voyageMissionData_1.EVoyageMissionType.FightAlienShip2,
        dangerLevel: 2,
        frames: sprites_sidecar_1.sprites.voyStarmapAlienShip,
    }))));
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Juggernaught',
        mission: voyageMissionData_1.EVoyageMissionType.FightAlienShip3,
        dangerLevel: 3,
        frames: sprites_sidecar_1.sprites.voyStarmapAlienShip,
    }))));
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Aliens 1',
        mission: voyageMissionData_1.EVoyageMissionType.FightAliens1,
        dangerLevel: 1,
        frames: sprites_sidecar_1.sprites.voyStarmapAliens,
    }))));
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Aliens 2',
        mission: voyageMissionData_1.EVoyageMissionType.FightAliens2,
        dangerLevel: 2,
        frames: sprites_sidecar_1.sprites.voyStarmapAliens,
    }))));
    locs.push.apply(locs, __spreadArray([], __read(createMultiple(3, {
        text: 'Aliens 3',
        mission: voyageMissionData_1.EVoyageMissionType.FightAliens3,
        dangerLevel: 3,
        frames: sprites_sidecar_1.sprites.voyStarmapAliens,
    }))));
    return locs;
}
exports.generateStandardLocations = generateStandardLocations;
